import { loginWithSessionAction } from '@/assets/js/api'
import { deviceName } from '@/assets/js/nativeServices'
import { addUserAlias, cleanJPushAll } from '@/assets/js/pushServices'
import { getLoginSessionLocalStorage, setLoginSessionLocalStorage, getJPushID, removeLoginSessionLocalStorage } from '@/assets/js/localStorage'

export const loginWithSession = (success, failure) => {
  let loginSession = getLoginSessionLocalStorage()
  let channel = 1
  if (loginSession && loginSession.session !== '') {
    loginWithSessionAction(loginSession.uuid, deviceName(), channel, loginSession.uid,
      loginSession.session, getJPushID()).then(res => {
      if (res.s === 0) {
        setLoginSessionLocalStorage(res.key, loginSession.session, res.token,
          loginSession.uid, loginSession.uuid)
        addUserAlias(loginSession.uid)
        success()
      } else {
        removeLoginSessionLocalStorage()
        cleanJPushAll()
        failure()
      }
    }).catch(err => {
      console.log('loginErro', err)
      removeLoginSessionLocalStorage()
      cleanJPushAll()
      failure()
    })
  } else {
    failure()
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/lifeCycle.js